(function () {
  function addClassOnScroll() {
    const windowTop = window.scrollY || document.documentElement.scrollTop || 0;

    const sections = document.querySelectorAll('section[id]');
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const offsetTop = rect.top + windowTop;
      const outerHeight = rect.height;

      if (windowTop > (offsetTop - 50) && windowTop < (offsetTop + outerHeight)) {
        const elemId = section.getAttribute('id');
        if (!elemId) return;

        // remove existing active
        document.querySelectorAll("nav ul li a.active").forEach((a) => a.classList.remove('active'));

        // add active to matching anchor
        const target = document.querySelector(`nav ul li a[href="#${CSS.escape(elemId)}"]`);
        if (target) target.classList.add('active');
      }
    });
  }

  // run once on load
  document.addEventListener('DOMContentLoaded', function () {
    addClassOnScroll();
    window.addEventListener('scroll', addClassOnScroll, { passive: true });
  });
})();
